<script>
    import { onMount } from "svelte";
    import CardLayout from "../../../../Components/Common/CardLayout.svelte";
    import Loader from "../../../../Components/Common/Loader.svelte";

     import {
        loggedInDoctorDetail,
        preOpQuestionnaires,
        postOpSurveys,
    } from "../../../../stores";
    import NotificationModal from "../../../../Components/Common/NotificationModal.svelte";

    import {
        cachePostOpSurvey,
        cachePreOpQuestionnaire,
        getFilteredPreOpInstructions,
    } from "../../../../Utils/utilCache.svelte";


    export let 
        UNLOCK_ALL_INPUTS = false,
        isFromCreate = false,
        disableInputScenario_TWO = false,
        patientEncounterDetails = {};
    
    let previousSelectedQuestionnaireID = 0,
        isConfirmActionModalOpen = false,
        isPreOpInstructionsLoading = false,
        filteredPreOpInstructions = [],
        isQuestionnairesLoading = false,
        isPostOpSurveyLoading = false;

    onMount(() => {
        loadPreOpQuestionnaires();

        loadPreOpInstructions();

        loadPostOpSurvey();

        previousSelectedQuestionnaireID =
            patientEncounterDetails.preOpQuestionnaireId;
    });


    const loadPreOpQuestionnaires = async () => {
        isQuestionnairesLoading = true;

        await cachePreOpQuestionnaire();

        // pre-select pre-op questionnaire if selected doctor has pre-selected pre-op questionnaire
        if (
            isFromCreate &&
            $loggedInDoctorDetail.preOpQuestionnaire &&
            $preOpQuestionnaires.length &&
            $preOpQuestionnaires.some(
                (p) => p.id == $loggedInDoctorDetail.preOpQuestionnaire,
            )
        )
            patientEncounterDetails.preOpQuestionnaireId =
                $loggedInDoctorDetail.preOpQuestionnaire;

        isQuestionnairesLoading = false;
    };

    const loadPreOpInstructions = async () => {
        isPreOpInstructionsLoading = true;

        filteredPreOpInstructions = await getFilteredPreOpInstructions(
            $loggedInDoctorDetail,
        );

        if (isFromCreate && $loggedInDoctorDetail.preOpInstructions)
            patientEncounterDetails.preOpInstructionsId =
                $loggedInDoctorDetail.preOpInstructions;

        isPreOpInstructionsLoading = false;
    };

    const loadPostOpSurvey = async () => {
        isPostOpSurveyLoading = true;

        await cachePostOpSurvey();

        isPostOpSurveyLoading = false;
    };

    const goToPreviewQuestionnaire = () => {
        if (
            patientEncounterDetails &&
            patientEncounterDetails.preOpQuestionnaireId &&
            $preOpQuestionnaires?.length
        ) {
            const selectedQuestionnaire = $preOpQuestionnaires.find(
                (q) => q.id === patientEncounterDetails.preOpQuestionnaireId,
            );
            if (selectedQuestionnaire)
                window.open(selectedQuestionnaire.url, "_blank");
        }
    };

    const goToPreviewPostOpSurvey = () => {
        if (
            patientEncounterDetails &&
            patientEncounterDetails.postOpSurveyId &&
            $postOpSurveys?.length
        ) {
            const selectedSurvey = $postOpSurveys.find(
                (s) => s.id === patientEncounterDetails.postOpSurveyId,
            );
            if (selectedSurvey) window.open(selectedSurvey.url, "_blank");
        }
    };

    const check72Hours = () => {
        if (
            patientEncounterDetails.scheduledDate &&
            patientEncounterDetails.preOpQuestionnaireId
        ) {
            const diffInHours =
                Math.abs(
                    new Date() -
                        new Date(patientEncounterDetails.scheduledDate),
                ) /
                (1000 * 60 * 60);

            isConfirmActionModalOpen = diffInHours <= 72;
        } else {
            previousSelectedQuestionnaireID =
                patientEncounterDetails.preOpQuestionnaireId;
        }
    };

    const resetQuestionnaire = () => {
        patientEncounterDetails.preOpQuestionnaireId =
            previousSelectedQuestionnaireID;
        isConfirmActionModalOpen = false;
    };

</script>

<CardLayout title="Send Documents" headerClass="card-layout-empty-header" cardClass="!border-0 pl-4 pr-4" enableCollapse={false}  >
    <div class="flex flex-col items-center gap-y-2">
        <!-- PreOp Questionnaire-->
        <div class="flex w-full items-center gap-x-2">
            <p class="title">PreOp Questionnaire:</p>
            {#if isQuestionnairesLoading}
                <div class="flex gap-x-2 items-center">
                    <Loader />
                    <p>Loading PreOp Questionnaire...</p>
                </div>
            {:else}
                <select
                    class="select flex-1 select-bordered select-sm w-remaining"
                    disabled={!UNLOCK_ALL_INPUTS &&
                        disableInputScenario_TWO}
                    bind:value={
                        patientEncounterDetails.preOpQuestionnaireId
                    }
                    on:change={check72Hours}
                >
                    <option
                        value={Number(0)}
                        selected={!patientEncounterDetails.preOpQuestionnaireId}
                    >
                        None
                    </option>
                    {#each $preOpQuestionnaires as op}
                        <option
                            value={op.id}
                            selected={patientEncounterDetails.preOpQuestionnaireId ===
                                op.id}
                        >
                            {op.name}
                        </option>
                    {/each}
                </select>

                {#if Number(patientEncounterDetails.preOpQuestionnaireId) && $preOpQuestionnaires?.length}
                    <button
                        class="btn btn-ghost btn-sm ml-2"
                        on:click|preventDefault={goToPreviewQuestionnaire}
                    >
                        Preview
                    </button>
                {/if}
            {/if}
        </div>

        <!-- PreOp Instructions -->
        <div class="flex w-full items-center gap-x-2">
            <p class="title">PreOp Instructions:</p>
            {#if isPreOpInstructionsLoading}
                <div class="flex gap-x-2 items-center">
                    <Loader />
                    <p>Loading PreOp Instructions...</p>
                </div>
            {:else}
                <select
                    class="select flex-1 select-bordered select-sm w-remaining"
                    disabled={!UNLOCK_ALL_INPUTS &&
                        disableInputScenario_TWO}
                    bind:value={patientEncounterDetails.preOpInstructionsId}
                >
                    <option
                        value={Number(0)}
                        selected={!patientEncounterDetails.preOpInstructionsId}
                    >
                        None
                    </option>
                    {#each filteredPreOpInstructions as op}
                        <option
                            value={op.id}
                            selected={patientEncounterDetails.preOpInstructionsId ===
                                op.id}
                        >
                            {op.name}
                        </option>
                    {/each}
                </select>
            {/if}
        </div>

        <!-- PostOp Survey -->
        <!-- <div class="flex w-full items-center">
            <p class="title">PostOp Survey:</p>
            {#if isPostOpSurveyLoading}
                <div class="flex gap-x-2 items-center">
                    <Loader />
                    <p>Loading PostOp Survey...</p>
                </div>
            {:else}
                <select
                    class="select flex-1 select-bordered select-sm"
                    disabled={!UNLOCK_ALL_INPUTS &&
                        disableInputScenario_TWO}
                    bind:value={patientEncounterDetails.postOpSurveyId}
                >
                    <option
                        value={Number(0)}
                        selected={!patientEncounterDetails.postOpSurveyId}
                    />
                    {#each $postOpSurveys as survey}
                        <option
                            value={survey.id}
                            selected={patientEncounterDetails.postOpSurveyId ===
                                survey.id}
                        >
                            {survey.name}
                        </option>
                    {/each}
                </select>

                {#if Number(patientEncounterDetails.postOpSurveyId) && $postOpSurveys?.length}
                    <button
                        class="btn btn-ghost btn-sm ml-2"
                        on:click|preventDefault={goToPreviewPostOpSurvey}
                    >
                        Preview
                    </button>
                {/if}
            {/if}
        </div> -->
    
    </div>
</CardLayout>


<NotificationModal
    isModalOpen={isConfirmActionModalOpen}
    title="Pre-Op Questionnaire Changed"
    cancelText="Cancel"
    submitText="Set and Send Now"
    cancelButtonClass="btn-accent"
    closeModal={() => resetQuestionnaire()}
    confirmAction={() => (isConfirmActionModalOpen = false)}
    closeModalFunction={resetQuestionnaire}
>
    <div class="flex flex-col gap-y-4">
        <p class="leading-6">
            This encounter is scheduled to less than 72 hours from now.
        </p>
        <p class="leading-6">
            Setting or changing the Pre-Op Questionnaire now will send an
            immediate notification to the patient to complete it.
        </p>
        <p class="leading-6">Do you want to continue?</p>
    </div>
</NotificationModal>


<style>
    .title {
        width: 200px;
    }

    .w-remaining {
        width: calc(100% - 200px);
    }
</style>
